// src/components/AdvTabs.jsx
import React, { useContext, } from 'react';
import AppContext from '../contexts/AppContext';
import { Carousel } from 'react-responsive-carousel';
import { advLog } from '../utils/Accesslog.js';
import { openDiscover } from '../utils/discover';


const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}

const AdvTabs = ({ origin }) => {
  const { advInfo, venueId, hotelInfo } = useContext(AppContext);

  const handleAdvClick = () => {
    openDiscover(hotelInfo?.area?.bitlyUrl);
    // Deprecated Discover navigation logic preserved for reference
    // const findNodeById = (tid, node, hist) => {
    //   const queue = [[node, hist]];
    //   while (queue.length > 0) {
    //     const [currentNode, currentHist] = queue.shift();
    //     if (currentNode.id === tid) return [currentNode, currentHist];
    //     if (currentNode.attributes) {
    //       queue.push(...currentNode.attributes.map((data) => [data, [...currentHist, currentNode.name]]));
    //     }
    //   }
    //   return [null, []];
    // };
    // if (id && contentInfo) {
    //   const [node, hist] = findNodeById(id, contentInfo, []);
    //   if (node && hist) {
    //     navigate(`/discover/detail/${id}`);
    //   }
    // }
  }

  return (
    <div style={{ boxShadow: '0 0.3rem 0.3rem rgba(0, 0, 0, 0.1)' }} className='flex justify-center items-center'>
      {/* All other place except Home */}
      {origin !== "Home" && advInfo && advInfo.length > 0 && (
        advInfo.length === 1 ?
          <img src={advInfo[0].image} alt='homeImage' className='object-cover w-full h-[56.25vw] xs:max-w-md xs:max-h-64' 
          onClick={() => {
            advLog(venueId, advInfo[0].id, origin || 'Home');
            handleAdvClick(advInfo[0].contentId);
          }}/>
          :
          <Carousel
            showArrows={false}
            showThumbs={false}
            infiniteLoop={true}
            autoPlay={true}
            showStatus={false}
            showIndicators={false}
            className="w-full h-full"
          >
            {shuffleArray(advInfo).map((data, index) => (
              <div key={index} className="w-full h-full"
                onClick={() => {
                  advLog(venueId, data.id, origin || 'Home');
                  handleAdvClick(data.contentId);
                  // navigate(`/discover/detail/${data.contentId}`);
                }}>
                <img
                  src={data.image}
                  alt={`Home Adv ${index + 1}`}
                  className="object-cover w-full h-[56.25vw] xs:max-w-md xs:max-h-64"
                />
              </div>
            ))}
          </Carousel>)}
      {origin === "Home" && advInfo && advInfo.filter(adv => adv.permissionLevel > 0).length > 0 && (
        advInfo.filter(adv => adv.permissionLevel > 0).length === 1 ?
          <img src={advInfo.filter(adv => adv.permissionLevel > 0)[0].image} alt='homeImage' className='object-cover w-full h-[56.25vw] xs:max-w-md xs:max-h-64'
          onClick={() => {
            advLog(venueId, advInfo.filter(adv => adv.permissionLevel > 0)[0].id, origin || 'Home');
            handleAdvClick(advInfo.filter(adv => adv.permissionLevel > 0)[0].contentId);
          }} />
          :
          <Carousel
            showArrows={false}
            showThumbs={false}
            infiniteLoop={true}
            autoPlay={true}
            showStatus={false}
            showIndicators={false}
            className="w-full h-full"
          >
            {shuffleArray(advInfo.filter(adv => adv.permissionLevel > 0)).map((data, index) => (
              <div key={index} className="w-full h-full"
                onClick={() => {
                  advLog(venueId, data.id, origin || 'Home');
                  handleAdvClick(data.contentId);
                  // navigate(`/discover/detail/${data.contentId}`);
                }}>
                <img
                  src={data.image}
                  alt={`Home Adv ${index + 1}`}
                  className="object-cover w-full h-[56.25vw] xs:max-w-md xs:max-h-64"
                />
              </div>
            ))}
          </Carousel>)}
    </div>
  );
};

export default AdvTabs;
